export const Category_EncounterDiagnosis = 'encounter-diagnosis';
export const Category_Infection = 'infection';
export const Category_ReasonForVisit = 'reason-for-visit';
export const Category_MedicalHistory = 'medical-history';
export const FHIR_Condition_CategoryOptions = [
    Category_ReasonForVisit,
    Category_EncounterDiagnosis,
    Category_Infection,
    Category_MedicalHistory,
];
export const FHIR_Condition_CategoryOptions_ToLabelsMap = {
    [Category_ReasonForVisit]: 'Reason For Visit',
    [Category_EncounterDiagnosis]: 'Encounter Diagnosis',
    [Category_Infection]: 'Infection',
    [Category_MedicalHistory]: 'Medical History',
};
//# sourceMappingURL=consts.js.map